import { css } from '@/styled-system/css';

export const comboboxEmptyStateStyles = css.raw({
  paddingBlock: 'tight',
  paddingInline: 'default',
  textStyle: 'body',
  color: 'text.action.neutral.default',
});
